import { nextTick } from 'vue';
import { createGlobalState, useStorage } from '@vueuse/core';

export const useState = createGlobalState(() => {

    //state
    const settingsState = useStorage('settingsState', { darkModeEnabled: true });



    //actions
    const setTheme = () => {
        if (settingsState.value.darkModeEnabled) {
            document.documentElement.style.setProperty('--bg-main', '#1e252f');
            document.documentElement.style.setProperty('--bg-comp', '#30353b'); //#12171e
            // document.documentElement.style.setProperty('--bg-crossword-square', '#3d444f');
            document.documentElement.style.setProperty('--light-black-n-dark-white','#ffffff');
            document.documentElement.style.setProperty('--light-white-n-dark-black','#000000');
        } else {
            document.documentElement.style.setProperty('--bg-main', '#f9f9f9');
            document.documentElement.style.setProperty('--bg-comp', '#eaeaea');
            // document.documentElement.style.setProperty('--bg-crossword-square', '#f9f9f9');
            document.documentElement.style.setProperty('--light-black-n-dark-white', '#000000');
            document.documentElement.style.setProperty('--light-white-n-dark-black', '#ffffff');
        }
    }

    const toggleTheme = async () => {
        settingsState.value.darkModeEnabled = !settingsState.value.darkModeEnabled;
        await nextTick();
        setTheme();
    }



    //useState
    return {
        settingsState,
        setTheme,
        toggleTheme
    }
});